import React, { Component } from 'react';
import { Frame, GetSDK, initComponents, SceneComponent, ISceneNode, ComponentInteractionType,
  orientedBoxType, slotType, OrientedBox, IComponentEventSpy, IInteractionEvent, sdkKey } from '@mp/common';
import { AppState } from '../AppState';
import { SceneLoader } from '../SceneLoader';
import { ItemList } from './ItemList';
import { ItemDesc } from 'src/types';
import { cameraInputType } from '@mp/common/src/sdk-components/Camera';
import { Vector3, Quaternion, Euler, Matrix4 } from 'three';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import * as THREE from 'three';

const SelectedColor = 0xffff00;
const SelectedOpacity = 0.1;
const SelectedLineOpacity = 1.0;
const UnselectedColor = 0xffffff;
const UnselectedOpacity = 0.04;
const UnselectedLineOpacity = 0.4;

interface Props {
  appState: AppState;
}

interface State {
  slotNode: SlotNode|null;
}

type SlotNode = {
  node: ISceneNode;
  slotComponent: SceneComponent;
  modelComponent: SceneComponent;
  boxComponent: OrientedBox;
}

export class Main extends Component<Props, State> {
  private sdk: any = null;
  private scene: SceneLoader = null;
  private slots: SlotNode[] = [];
  private cameraInput: SceneComponent;
  private src: string;
  private applicationKey: string;
  private animIndex: number = 0;
  // private sceneObject: any;

  // private mixer: THREE.AnimationMixer | null = null;
  // private clipAction: THREE.AnimationAction | null = null;

  constructor(props: Props) {
    super(props);

    this.state = {
      slotNode: null,
    };

    // Forward url params.
    const params = objectFromQuery();
    // params.m = params.m || 'j4RZx7ZGM6T';
    // params.m = params.m || 'AN8SRFMXb2V'; // office
    // params.m = params.m || 'eJbJRi8npa4'; // 牛池灣
    params.m = params.m || 'ZQsBZAANf8H'; // 寶福餐廳
    params.play = params.play || '1';
    params.qs = params.qs || '1';
    params.sr = params.sr || '-.15';
    params.ss = params.ss || '25';
    // ensure applicationKey is inserted into the bundle query string
    params.applicationKey = params.applicationKey || sdkKey;
    this.applicationKey = params.applicationKey;

    const queryString = Object.keys(params).map((key) => key + '=' + params[key]).join('&');
    this.src = `./bundle/showcase.html?${queryString}`;

    this.handleListSelection = this.handleListSelection.bind(this);
  }

  async componentDidMount() {
    this.sdk = await GetSDK('sdk-iframe', this.applicationKey);
    await initComponents(this.sdk);
    await this.createCameraControl(this.sdk);
    await this.sdk.Scene.configure((renderer: any, three: any) => {
      renderer.physicallyCorrectLights = true;
      renderer.outputEncoding = three.sRGBEncoding;
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.bias = 0.0001;
      renderer.shadowMap.type = three.PCFSoftShadowMap;

    });
    this.scene = new SceneLoader(this.sdk);

    const slots: SlotNode[] = [];

    class ClickSpy implements IComponentEventSpy<IInteractionEvent> {
      public eventType = ComponentInteractionType.CLICK;
      constructor(private mainComponent: Main){}
      onEvent(payload: IInteractionEvent) {
        
        // console.log('click!!!');
        // console.log('click', payload);
        // console.log('click', payload.component.componentType);

        if (payload.component != null && payload.component.componentType === orientedBoxType) {
          this.mainComponent.handleOrientedBoxInteraction(payload.node, payload.component, payload.type);
        }
        // else if (payload.component.componentType === "mp.fbxLoader") {
        //   this.mainComponent.handleFbxInteraction(payload.node, payload.component, payload.type);
        // }
      }
    }

    class HoverSpy implements IComponentEventSpy {
      public eventType = ComponentInteractionType.HOVER;
      constructor(private mainComponent: Main) {}
      onEvent(payload: { hover: boolean; }) {
        this.mainComponent.cameraInput.inputs.suppressClick = !payload.hover;
      }
    }

    const clickSpy = new ClickSpy(this);
    const hoverSpy = new HoverSpy(this);
    const findSlots = (node: ISceneNode) => {
      let slot: SceneComponent = null;
      let model: SceneComponent = null;
      let box: OrientedBox = null;
      const componentIterator: IterableIterator<SceneComponent> = node.componentIterator();
      for (const component of componentIterator) {
        if (component.componentType === slotType) {
          slot = component;
        }
        else if (component.componentType === 'mp.gltfLoader') {
          model = component;
        }
        else if (component.componentType === 'mp.fbxLoader') {
          model = component;
          model.spyOnEvent(clickSpy);
        }
        else if (component.componentType == orientedBoxType) {
          box = component as OrientedBox;
          box.spyOnEvent(clickSpy);
          box.spyOnEvent(hoverSpy);
          box.inputs.color = UnselectedColor;
          box.inputs.opacity = UnselectedOpacity;
        }
      }

      if (slot && model) {
        slots.push({
          node: node,
          slotComponent: slot,
          modelComponent: model,
          boxComponent: box,
        })
      }
    };
    
    this.slots = slots;
    await this.scene.load('AAWs9eZ9ip6', findSlots);
    // await this.scene.load('AN8SRFMXb2V', findSlots);

    console.log(this.scene);
    console.log(this.sdk);

    // this.sceneObject = await this.sdk.Scene.createObjects(1);
  }

  private handleListSelection(item: ItemDesc) {
    const slotNode = this.state.slotNode;
    if (!slotNode) {
      return;
    }
    slotNode.slotComponent.inputs. model = item.url;
    slotNode.modelComponent.inputs.localPosition.x = item.position.x;
    slotNode.modelComponent.inputs.localPosition.y = item.position.y;
    slotNode.modelComponent.inputs.localPosition.z = item.position.z;
    slotNode.modelComponent.inputs.localRotation.x = item.rotation.x;
    slotNode.modelComponent.inputs.localRotation.y = item.rotation.y;
    slotNode.modelComponent.inputs.localRotation.z = item.rotation.z;
    slotNode.modelComponent.inputs.localScale.x = item.scale.x;
    slotNode.modelComponent.inputs.localScale.y = item.scale.y;
    slotNode.modelComponent.inputs.localScale.z = item.scale.z;

    // Can add component from here
    // Add a condition to check if the item is fbx
    if (slotNode.node.name == 'slot_4')
    {
      console.log('List selection for slot_4');

      // Add animator component

      // Use FBXLoader to load the animation file

      // Set the paths to the animator component.
    }
  }

  // private handleFbxInteraction(node: ISceneNode, component: SceneComponent, interactionType: ComponentInteractionType) {
  //   if (interactionType === ComponentInteractionType.CLICK) {
  //     console.log('fbx clicked');
  //   }
  // }

  private handleOrientedBoxInteraction(node: ISceneNode, component: SceneComponent, interactionType: ComponentInteractionType) {
    if (interactionType === ComponentInteractionType.CLICK) {
      // select this node
      for (const slot of this.slots) {
        if (slot.boxComponent === component) {
          const lastSlotNode = this.state.slotNode;
          if (lastSlotNode) {
            lastSlotNode.boxComponent.inputs.color = UnselectedColor;
            lastSlotNode.boxComponent.inputs.opacity = UnselectedOpacity;
            lastSlotNode.boxComponent.inputs.lineOpacity = UnselectedLineOpacity;
          }

          if (lastSlotNode === slot) {
            this.cameraInput.inputs.focus = null;

            this.setState({
              slotNode: null,
            });
          } else {
            this.setState({
              slotNode: slot,
            })

            slot.boxComponent.inputs.color = SelectedColor;
            slot.boxComponent.inputs.opacity = SelectedOpacity;
            slot.boxComponent.inputs.lineOpacity = SelectedLineOpacity;
            this.cameraInput.inputs.focus = node.position;
          }

          if (slot.modelComponent.componentType === 'mp.fbxLoader') 
          {
            if (slot.modelComponent.outputs.objectRoot === null) 
            {
              console.log('model not loaded yet');
              return;
            }

            console.log('model loaded. do sth to the model');

            // let mixer: THREE.AnimationMixer
            // const animationActions: THREE.AnimationAction[] = []
            const fbxLoader = new FBXLoader()

            let url = '';
            if (this.animIndex === 0) {
              // url = 'https://snappop.s3.amazonaws.com/models/x_bot@capoeira.fbx';
              url = 'https://snappop.s3.amazonaws.com/models/human_clean_rig@breathing_idle.fbx';
              this.animIndex = 1;
            } else if (this.animIndex === 1) {
              // url = 'https://snappop.s3.amazonaws.com/models/x_bot@defeated.fbx';
              url = 'https://snappop.s3.amazonaws.com/models/human_clean_rig@talking.fbx';
              this.animIndex = 2;
            } else {
              url = 'https://snappop.s3.amazonaws.com/models/human_clean_rig@walking_around.fbx';
              this.animIndex = 0;
            }

            fbxLoader.load(
              url,
              (object) => {
                console.log('fbx loaded ', object)
                // mixer = new THREE.AnimationMixer(object)
                // const animationAction = mixer.clipAction(
                //   (object as THREE.Object3D).animations[0]
                // )
                // animationActions.push(animationAction)
                // animationAction.play()

                const componentIterator: IterableIterator<SceneComponent> = slot.node.componentIterator();
                for (const component of componentIterator) {
                  if (component.componentType === 'mp.animator') {
                    console.log('animator component found')
                    component.inputs.object = slot.modelComponent.outputs.objectRoot
                    component.inputs.clip = (object as THREE.Object3D).animations[0]
                    component.inputs.animationSpeed = 1
                  }
                }
                
              }
            )

            // const anotherNode = this.sceneObject.createNode();
            // const fbxAnim = anotherNode.addComponent('mp.fbxLoader', {
            //   url: 'https://snappop.s3.amazonaws.com/models/x_bot@capoeira.fbx'
            // });
            // // Spy on fbxAnim's output's loadingState
            // fbxAnim.spyOnEvent({
            //   eventType: 'loadingState',
            //   onEvent: (payload: any) => {
            //     console.log('fbxAnim loadingState', payload);
            //   }
            // });
            // anotherNode.start();

          }
        }
      }
    }
  }

  render() {
    let filteredItems: ItemDesc[] = [];
    const { slotNode } = this.state;

    if (slotNode) {
      const { items, slots } = this.props.appState;
      const category = slots.get(slotNode.node.name);

      if (category) {
        filteredItems = items.get(category);
      }
    }

    return (
      <div className='main'>
        <ItemList items={filteredItems} onSelected={this.handleListSelection}></ItemList>
        <Frame src={this.src}></Frame>
      </div>
    );
  }

  async createCameraControl(theSdk: any) {
    const cameraNode = await theSdk.Scene.createNode();
    const cameraPose = await theSdk.Camera.getPose();
    this.cameraInput = cameraNode.addComponent(cameraInputType);
    // convert sdk pose to THREE.js objects
    this.cameraInput.inputs.startPose = {
      position: new Vector3(cameraPose.position.x, cameraPose.position.y, cameraPose.position.z),
      quaternion: new Quaternion().setFromEuler(new Euler(
        cameraPose.rotation.x * Math.PI / 180,
        cameraPose.rotation.y * Math.PI / 180,
        (cameraPose.rotation.z || 0) * Math.PI / 180,
        'YXZ')),
      projection: new Matrix4().fromArray(cameraPose.projection).transpose(),
    };
    const cameraControl = cameraNode.addComponent('mp.camera');
    cameraControl.bind('camera', this.cameraInput, 'camera');

    cameraNode.start();
  }
}

// from cwf/modules/browser.ts
export const objectFromQuery = (url?: string): {[key: string]: string} => {
  const regex = /[#&?]([^=]+)=([^#&?]+)/g;
  url = url || window.location.href;
  const object: { [param: string]: string } = {};
  let matches;
  // regex.exec returns new matches on each
  // call when we use /g like above
  while ((matches = regex.exec(url)) !== null) {
    object[matches[1]] = decodeURIComponent(matches[2]);
  }
  return object;
};
